export default "__VITE_ASSET__CfW5ua8J__"